/**
 * @description Конфигурация роутера. ФАЙЛ НЕ ТРОГАТЬ!!!!!!!!!!!
 */

import HomeView from '@/views/HomeView.vue'
import UserPage from '@/views/UserView.vue'
import CompanyView from '@/views/CompanyView.vue'

import { COMPANY_GROUPS as COMPANY_GROUPS_ARRAY } from './companyGroupsConfig'
import { COMPANY_SETTINGS_PAGES, COMPANY_PERSONAL_SETTINGS_PAGES } from '@/config/router/companySettingsPagesConfig'
import { COMPANY_REFERENCE_MATERIALS_PAGES } from '@/config/router/companyReferenceMaterialsPagesConfig'
import { COMPANY_CARDS } from './companyCardsConfig'
import { COMPANY_GENERATORS } from './companyGeneratorsConfig'
import { COMPANY_CONSTRUCTORS } from './companyConstructorsConfig'

import { NAVIGATION_ROUTE_TYPES, NAVIGATION_LAYERS } from './routerMapConfig'

export const COMPANY_GROUPS = COMPANY_GROUPS_ARRAY

// export const USER_SETTINGS_PAGES = [
// 	{
// 		path: 'profile',
// 		name: 'CompanyProfilePage',
// 		component: () => import('@/views/company/settings-pages/CompanySettingsProfileView.vue'),
// 		meta: {
// 			navigationLayer: NAVIGATION_ROUTE_TYPES.profileSettings.key,
// 			title: 'Профиль пользователя',
// 		},
// 	},
// ]
export const USER_PAGES = [
	{
		path: 'profile',
		name: 'UserProfilePage',
		component: () => import('@/views/user/UserProfileView.vue'),
		meta: {
			navigationRouteType: NAVIGATION_LAYERS.userPages.key,
			titleTranslationKey: 'User Profile',
			activeHeader: false,
		},
	},
	// {
	// 	path: 'access-rights',
	// 	name: 'UserAccessRightsPage',
	// 	component: () => import('@/views/user/UserAccessRightsView.vue'),
	// 	meta: {
	// 		navigationLayer: NAVIGATION_LAYERS.userPages.key,
	// 		titleTranslationKey: 'Access rights',
	// 		activeHeader: true,
	// 	},
	// },
	// {
	// 	path: 'reports-settings',
	// 	name: 'UserReportsSettingsPage',
	// 	component: () => import('@/views/user/UserReportsSettingsView.vue'),
	// 	meta: {
	// 		navigationLayer: NAVIGATION_LAYERS.userPages.key,
	// 		titleTranslationKey: 'Report settings',
	// 	},
	// },
]

export const DEVELOPERS_PAGES = [
	{
		path: 'components',
		name: 'DevComponentsPage',
		component: () => import('@/views/dev/ComponentsView.vue'),
		meta: {
			navigationRouteType: NAVIGATION_ROUTE_TYPES.group.key,
			title: 'Components',
		},
		children: [
			{
				path: 'ao-filter-checkbox',
				name: 'DevComponentsFilterCheckboxPage',
				component: () => import('@/views/dev/components-group/CheckboxView.vue'),
				meta: {},
			},
			{
				path: 'ao-checkboxes',
				name: 'DevComponentsCheckboxesPage',
				component: () => import('@/views/dev/components-group/CheckboxesView.vue'),
				meta: {},
			},
			{
				path: 'ao-radios',
				name: 'DevComponentsRadiosPage',
				component: () => import('@/views/dev/components-group/RadiosView.vue'),
				meta: {},
			},
			{
				path: 'ao-range-sliders',
				name: 'DevComponentsRangeSlidersPage',
				component: () => import('@/views/dev/components-group/RangeSlidersView.vue'),
				meta: {},
			},
			{
				path: 'ao-date-range-picker',
				name: 'DevComponentsDatePicker',
				component: () => import('@/views/dev/components-group/DatePickerView.vue'),
				meta: {},
			},
			{
				path: 'ao-tooltip',
				name: 'DevGroupComponentsTooltip',
				component: () => import('@/views/dev/components-group/AoTooltipView.vue'),
				meta: {},
			},
			{
				path: 'ao-pickers',
				name: 'DevGroupComponentsPickers',
				component: () => import('@/views/dev/components-group/PickersView.vue'),
				meta: {},
			},
			{
				path: 'ao-button-toggle',
				name: 'DevGroupComponentsButtonToggle',
				component: () => import('@/views/dev/components-group/ButtonToggleView.vue'),
				meta: {},
			},
			{
				path: 'ao-ratings',
				name: 'DevGroupComponentsRatings',
				component: () => import('@/views/dev/components-group/RatingsView.vue'),
				meta: {},
			},
			{
				path: 'ao-select-group',
				name: 'DevGroupComponentsSelectGroup',
				component: () => import('@/views/dev/components-group/SelectGroupView.vue'),
				meta: {},
			},
			// RangeSlidersView
			{
				path: 'ao-checkboxes-collapse',
				name: 'DevComponentCheckboxesCollapsePage',
				component: () => import('@/views/dev/components-group/CheckBoxesCollapseView.vue'),
				meta: {},
			},

			{
				path: 'ao-tabs',
				name: 'AoTabs',
				component: () => import('@/views/dev/components-group/AoTabsView.vue'),
				meta: {},
			},
			{
				path: 'ao-file-input',
				name: 'aoFileInput',
				component: () => import('@/views/dev/components-group/AoFileInputView.vue'),
				meta: {},
			},
			{
				path: 'ao-file-input-avatar',
				name: 'aoFileInputAvatar',
				component: () => import('@/views/dev/components-group/AoFileInputAvatarView.vue'),
				meta: {},
			},
			{
				path: 'ao-carousel-view',
				name: 'aoCarouselView',
				component: () => import('@/views/dev/components-group/AoCarouselView.vue'),
				meta: {},
			},
			{
				path: 'group-ations-view',
				name: 'aoGroupActionsCardView',
				component: () => import('@/views/dev/components-group/GroupActions.vue'),
				meta: {},
			},
			{
				path: 'ao-color-input-view',
				name: 'AoColorInputView',
				component: () => import('@/views/dev/components-group/AoColorInputView.vue'),
				meta: {},
			},
			// {
			// 	path: 'ao-checkboxes-collapse-list',
			// 	name: 'DevComponentCheckboxesCollapseListPage',
			// 	component: () => import('@/views/dev/components-group/CheckBoxesCollapseListView.vue'),
			// 	meta: {},
			// },
		],
	},
	{
		path: 'colors',
		name: 'ColorsPage',
		component: () => import('@/views/dev/ColorsView.vue'),
		meta: {
			subMenu: 'colors',
		},
	},
	{
		path: 'cache-service',
		name: 'CacheService',
		component: () => import('@/views/dev/CacheServiceView.vue'),
		meta: {
			subMenu: 'cache-service',
		},
	},
	{
		path: 'icons',
		name: 'Icon library',
		component: () => import('@/views/dev/IconsView.vue'),
	},
]


/**
 * @description НЕ ТРОГАТЬ!!!! РУКИ ПРОЧЬ!!!!!!!!!!!!!
 * @author kovalevadim
 */
const BASE_LEVEL = [
	{
		path: '/',
		name: 'HomePage',
		component: HomeView,
		meta: {
			navigationRouteType: NAVIGATION_ROUTE_TYPES.base.key,
		},
	},
	{
		path: '/user',
		name: 'UserPage',
		component: UserPage,
		meta: {
			navigationRouteType: NAVIGATION_ROUTE_TYPES.base.key,
		},
		children: USER_PAGES,
	},
	{
		path: '/c/:companyId',
		name: 'CompanyPage',
		component: CompanyView,
		meta: {
			navigationRouteType: NAVIGATION_ROUTE_TYPES.base.key,
		},
		children: [
			{
				path: 'dashboard',
				name: 'CompanyDashboardPage',
				component: { template: '<h2>Dashboard Company page</h2>' },
				children: [],
			},
			...COMPANY_GROUPS,
			{
				path: 'cards',
				name: 'CompanyCardsPage',
				component: () => import('@/views/company/CompanyCardsView.vue'),
				children: COMPANY_CARDS,
			},
			{
				path: 'generators',
				name: 'CompanyGeneratorsPage',
				component: () => import('@/views/company/CompanyGeneratorsView.vue'),
				children: COMPANY_GENERATORS,
			},
			{
				path: 'constructors',
				name: 'CompanyConstructorsPage',
				component: () => import('@/views/company/CompanyConstructorsView.vue'),
				children: COMPANY_CONSTRUCTORS,
			},
			// reference-materials
			// CompanyReferenceMaterialsTestView
			{
				path: 'reference-materials',
				name: 'CompanyReferenceMaterialsPage',
				component: () => import('@/views/company/CompanyReferenceMaterialsView.vue'),
				children: COMPANY_REFERENCE_MATERIALS_PAGES,
			},
			// {
			// 	path: 'settings',
			// 	name: 'CompanySettingsPage',
			// 	children: SYSTEM_SETTINGS_PAGES,
			// 	component: () => import('@/views/company/CompanySystemSettingsView.vue'),
			// },
			{
				path: 'company-settings',
				name: 'ProfileAndCompanySettingsPage',
				children: [
					...COMPANY_SETTINGS_PAGES,
					...COMPANY_PERSONAL_SETTINGS_PAGES,
				],
				component: () => import('@/views/company/CompanySystemSettingsView.vue'),
			},
			{
				path: 'notifications',
				name: 'CompanyNotificationsPage',
				component: () => import('@/views/company/my-tasks-group/notifications-module/CompanyModuleNotificationsTableView.vue'),
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.profileSettings.key,
					titleTranslationKey: 'Notifications',
				},
			},
			{
				path: 'redirect',
				name: 'CompanyRedirectPage',
				component: () => import('@/views/company/CompanyRedirectView.vue'),
			},
		],
	},
	{
		path: '/create-company',
		name: 'CreateCompanyPage',
		component: () => import('@/views/CreateCompanyView.vue'),
		meta: {
			navigationLayer: NAVIGATION_ROUTE_TYPES.profileSettings.key,
			title: 'Cоздать компанию',
		},
	},
	{
		path: '/redirect',
		name: 'RedirectPage',
		component: () => import('@/views/RedirectView.vue'),
	},
	// RISK(RISK-017)[S3/безопасность]: маршрут /dev добавлен в BASE_LEVEL безусловно, без guard и без
	// meta.hideInProduction — dev-страницы доступны в проде по прямому URL (hideInProduction скрывает
	// только пункты меню). Решение: guard по env-режиму или исключение из прод-сборки.
	// Подробнее: docs/audit/04_risks_register.md (RISK-017)
	{
		path: '/dev',
		name: 'DevelopersPage',
		component: () => import('@/views/DevelopersView.vue'),
		children: DEVELOPERS_PAGES,
		meta: {
			navigationRouteType: NAVIGATION_ROUTE_TYPES.base.key,
		},
	},
]

export default BASE_LEVEL
